export default "__VITE_ASSET__46a8e7c4__"